/**
 * Support contact email shown in the portal.
 *
 * The DOMAIN is derived from the portal's own host at runtime (registrable
 * domain = last two labels) so it tracks the deploy target (`.ca` prod / `.cc`
 * staging) with zero per-environment config — mirrors `marketing-url.ts`
 * (`derivedMarketingUrl`). We never bake a TLD (Phase-14a-1: no env-specific
 * hostnames in shared config; a mismatched-domain support address reads as a
 * phishing red flag). The local-part (`info`) is stable and exists on both.
 */
function derivedSupportEmail(): string {
  if (typeof window === 'undefined') return 'info@truecarepartners.ca';
  const host = window.location.host.split(':')[0] ?? '';
  const labels = host.split('.');
  // registrable domain (our TLDs are two-label); localhost/dev falls back.
  const base = labels.length >= 2 ? labels.slice(-2).join('.') : 'truecarepartners.ca';
  return `info@${base}`;
}

/** e.g. `info@truecarepartners.ca` (prod) / `info@truecarepartners.cc` (staging). */
export const SUPPORT_EMAIL = derivedSupportEmail();
